import EstimateList from "@/components/Estimates/EstimateList.vue";
import EstimateEdit from "@/components/Estimates/EstimateEdit.vue";
import EstimateHeader from "@/components/Estimates/EstimateHeader.vue";

export default [
    {
        path: "/estimates",
        alias: ["/estimate"],
        name: "Estimates",
        redirect: "/estimate/list",
        components: {
            page: EstimateList,
            header: EstimateHeader
        },
        meta: {
            title: "Estimates",
            requiresAuth: true
        },
        children: [
            {
                path: "/estimate/list",
                name: "Estimate List",
                components: {
                    // Empty - uses parent page component
                }
            },
            {
                path: "/estimate/edit/:id",
                name: "Estimate Edit",
                components: {
                    modal: EstimateEdit
                }
            }
        ]
    }
];
